import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const appCardVariants = cva("rounded-2xl border border-border bg-card", {
  variants: {
    variant: {
      flat: "shadow-sm",
      elevated: "shadow-md",
    },
    padding: {
      none: "",
      md: "p-4",
      lg: "p-6",
    },
  },
  defaultVariants: {
    variant: "flat",
    padding: "md",
  },
});

type TAppCardProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof appCardVariants> & {
    as?: React.ElementType;
    type?: string;
  };

export function AppCard({ as: Component = "div", className, variant, padding, ...props }: TAppCardProps) {
  return (
    <Component
      className={cn(appCardVariants({ variant, padding }), className)}
      {...props}
    />
  );
}
